// src/common/components/cartModal/components/bonusInfo/BonusInfo.tsx
import React, { useMemo } from "react";
import { MdCardGiftcard } from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./BonusInfo.module.scss";

interface BonusInfoProps {
  balance: number;
  percent: number;
}

export default function BonusInfo({ balance, percent }: BonusInfoProps) {
  const { theme } = useTheme();

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: theme.card,
        borderColor: theme.border,
      }}
    >
      <div className={styles.header}>
        <MdCardGiftcard
          size={24}
          color={theme.primary}
          className={styles.icon}
        />
        <h3 className={styles.title} style={{ color: theme.text }}>
          Мои бонусы
        </h3>
      </div>

      <div className={styles.row}>
        <span className={styles.label} style={{ color: theme.textSecondary }}>
          Доступно
        </span>
        <span className={styles.value} style={{ color: theme.text }}>
          {balance} ₽
        </span>
      </div>

      <div className={styles.row}>
        <span className={styles.label} style={{ color: theme.textSecondary }}>
          Кешбэк за заказ
        </span>
        <div
          className={styles.percentContainer}
          style={{ backgroundColor: `${theme.primary}` }}
        >
          <span
            className={styles.percentText}
            style={{ color: theme.onPrimary }}
          >
            {percent}%
          </span>
        </div>
      </div>
    </div>
  );
}
